import React, {ReactNode} from 'react';
import Fundial from './Fundial';
import Page, {PageType} from '@episerver/spa-core/Page';
import FundialPageData from '../../../Models/Content/FundialPageData';

export default class FundialPage extends Page<FundialPageData> {
  public render(): ReactNode {
    return <Fundial context={this.getContext()} iContent={this.props.data} />;
  }
}
